export default "__VITE_ASSET__DKS0etoE__"